// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New order page + SearchSelect + ProductPickerModal.
   Depends on dashboard-redesign.css for the shell (.rf-app, .rf-topbar,
   .rf-btn, .rf-serif, .rf-spacer, .rf-check, .rf-link). Load that first. */

/* ================= layout ================= */
.rf-neworder {
  flex-grow: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}
.rf-neworder-body {
  flex-grow: 1;
  min-height: 0;
  display: flex;
}
.rf-form {
  flex-grow: 1;
  min-width: 0;
  padding: 22px 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  /* no overflow:hidden — picker panels must escape these cards */
}

/* ================= step bar ================= */
.rf-steps {
  background: #fff;
  border-bottom: 1px solid #e7e3da;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.rf-step {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 18px 0 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: inherit;
}
.rf-step-badge {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  border: 1.5px solid #e7e3da;
  background: #fff;
  color: #a29b8d;
}
.rf-step.is-active .rf-step-badge {
  background: #191714;
  border-color: #191714;
  color: #fff;
}
.rf-step.is-done .rf-step-badge {
  background: var(--rf-brand-tint);
  border-color: var(--rf-brand-line);
  color: var(--rf-brand);
}
.rf-step-label {
  font-size: 13.5px;
  font-weight: 500;
  color: #a29b8d;
  white-space: nowrap;
}
.rf-step.is-active .rf-step-label {
  font-weight: 600;
  color: #191714;
}
.rf-step.is-done .rf-step-label {
  color: #4a453c;
}
.rf-step-line {
  width: 34px;
  height: 1.5px;
  background: #e7e3da;
  display: block;
  margin-left: 8px;
}
.rf-step:last-of-type .rf-step-line {
  display: none;
}
.rf-step.is-done .rf-step-line {
  background: #d8cfb8;
}
.rf-steps-meta {
  font-size: 12.5px;
  color: #8b8477;
  white-space: nowrap;
}

/* ================= fields ================= */
.rf-form-bar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.rf-form-bar-note {
  font-size: 12.5px;
  color: #8b8477;
  white-space: nowrap;
}
.rf-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
}
.rf-grid-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 14px 16px;
  margin-bottom: 16px;
}
.rf-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}
.rf-field-picker {
  position: relative;
}
.rf-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #8b8477;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}
.rf-req {
  color: #a8483e;
}
.rf-input-shell {
  height: 38px;
  border: 1px solid #e7e3da;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 8px;
}
.rf-input-shell input {
  flex-grow: 1;
  min-width: 0;
  border: none;
  background: none;
  outline: none;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.rf-input-shell input::placeholder {
  color: #bdb6a7;
}
.rf-input-shell:focus-within {
  border-color: var(--rf-brand-lite);
}
.rf-input-shell.is-picker {
  cursor: pointer;
}
.rf-input-shell.is-picker:hover,
.rf-input-shell.is-open {
  border-color: var(--rf-brand-lite);
}
.rf-picker-value {
  flex-grow: 1;
  min-width: 0;
  font-size: 13.5px;
  color: #191714;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-picker-placeholder {
  flex-grow: 1;
  min-width: 0;
  font-size: 13.5px;
  color: #a29b8d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-affordance {
  font-size: 11px;
  color: #bdb6a7;
  white-space: nowrap;
  flex-shrink: 0;
}
.rf-hint {
  font-size: 11.5px;
  color: #a29b8d;
}
.rf-hint.is-warn {
  color: #a8483e;
}

/* picker panel positioning — the component itself is position-agnostic */
.rf-picker-panel {
  position: absolute;
  left: 0;
  width: 100%;
  min-width: 380px;
  z-index: 40;
}
.rf-picker-panel.is-down {
  top: 62px;
}
.rf-picker-panel.is-up {
  bottom: 48px;
}
.rf-picker-wide {
  max-width: 520px;
  min-width: 420px;
}

/* ================= person record card ================= */
.rf-person-block {
  position: relative;
  margin-bottom: 14px;
}
.rf-person {
  border: 1.5px solid #d8cfb8;
  background: var(--rf-brand-wash);
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  align-items: flex-start;
  gap: 13px;
}
.rf-person-chip {
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: #f0e3c8;
  color: var(--rf-brand-deep);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
}
.rf-person-main {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.rf-person-head {
  display: flex;
  align-items: center;
  gap: 9px;
  flex-wrap: wrap;
}
.rf-person-name {
  font-size: 19px;
  line-height: 1.15;
  color: #191714;
}
.rf-person-badge {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--rf-brand-deep);
  background: #f0e3c8;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
}
.rf-person-dates {
  font-size: 12px;
  color: #8b8477;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.rf-person-facts {
  display: flex;
  flex-wrap: wrap;
}
.rf-person-fact {
  padding-right: 20px;
  margin-right: 20px;
  border-right: 1px solid var(--rf-brand-line);
}
.rf-person-fact:last-child {
  border-right: none;
  margin-right: 0;
  padding-right: 0;
}
.rf-person-fact-k {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #a29b8d;
  white-space: nowrap;
  margin-bottom: 2px;
}
.rf-person-fact-v {
  font-size: 12.5px;
  font-weight: 500;
  color: #191714;
  white-space: nowrap;
}
.rf-person-warn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid #f0e3c8;
  font-size: 12px;
  color: #6f6a60;
  text-wrap: pretty;
}
.rf-person-warn-bar {
  width: 3px;
  height: 18px;
  border-radius: 2px;
  background: #b0872f;
  flex-shrink: 0;
}
.rf-person-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-end;
  flex-shrink: 0;
}

/* ================= destination pickers ================= */
.rf-dest {
  border: 1px solid #eee9df;
  background: #fbf9f5;
  border-radius: 10px;
  padding: 13px 15px;
}
.rf-dest-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 9px;
}
.rf-dest-title {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
}
.rf-dest-time {
  font-size: 11.5px;
  color: #a29b8d;
  white-space: nowrap;
}
.rf-dest-address {
  font-size: 13px;
  color: #191714;
  line-height: 1.4;
  text-wrap: pretty;
  margin-top: 9px;
}
.rf-segmented.is-full {
  width: 100%;
}
.rf-segmented.is-full button {
  flex-grow: 1;
  padding: 5px 8px;
  font-size: 11.5px;
}

/* ================= live summary rail ================= */
.rf-rail {
  width: 392px;
  flex-shrink: 0;
  border-left: 1px solid #e7e3da;
  background: #fff;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.rf-rail-head {
  padding: 18px 20px 14px;
  border-bottom: 1px solid #f0ece3;
  flex-shrink: 0;
}
.rf-rail-name {
  font-size: 22px;
  line-height: 1.15;
  color: #191714;
  margin-top: 4px;
}
.rf-rail-meta {
  font-size: 12.5px;
  color: #6f6a60;
  margin-top: 3px;
}
.rf-rail-body {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.rf-rail-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.rf-rail-group-title {
  font-size: 12.5px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
}
.rf-rail-lines {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rf-rail-line {
  border: 1px solid #e7e3da;
  border-radius: 9px;
  padding: 9px 11px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.rf-rail-line:hover {
  border-color: #d8cfb8;
}
.rf-rail-accent {
  width: 3px;
  height: 26px;
  border-radius: 2px;
  background: var(--rf-brand-lite);
  flex-shrink: 0;
}
.rf-rail-line-text {
  flex-grow: 1;
  min-width: 0;
}
.rf-rail-line-name {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-rail-line-detail {
  font-size: 11.5px;
  color: #a29b8d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* the sash wording, under its product — wraps, because the message is a
   sentence and the whole point is being able to read it here */
/* "2 × \$440.00 each + sash \$30.00" */
.rf-rail-line-calc {
  margin-top: 2px;
  font-size: 11.5px;
  color: #6f6a60;
  font-variant-numeric: tabular-nums;
}
.rf-rail-line-sash {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-top: 3px;
}
.rf-rail-sash-k {
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--rf-brand);
  flex-shrink: 0;
}
.rf-rail-sash-v {
  font-size: 11.5px;
  line-height: 1.35;
  color: #4a453c;
  overflow-wrap: anywhere;
  text-wrap: pretty;
}
.rf-rail-qty {
  font-size: 12.5px;
  color: #4a453c;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.rf-rail-price {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.rf-rail-remove {
  border: none;
  background: none;
  padding: 0;
  font-size: 14px;
  line-height: 1;
  color: #c4bdad;
  cursor: pointer;
}
.rf-rail-remove:hover {
  color: #a8483e;
}
.rf-rail-empty {
  width: 100%;
  border: 1px dashed #ddd7cb;
  border-radius: 9px;
  padding: 14px;
  background: none;
  text-align: center;
  font: 400 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #a29b8d;
  cursor: pointer;
}
.rf-rail-empty:hover {
  border-color: #d8cfb8;
  color: var(--rf-brand);
}
.rf-rail-totals {
  margin-top: auto;
  border-top: 1px solid #f0ece3;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.rf-rail-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12.5px;
  color: #8b8477;
}
.rf-rail-total-row span:last-child {
  color: #4a453c;
  font-variant-numeric: tabular-nums;
}
.rf-rail-total-row.is-total {
  font-size: 15px;
  font-weight: 600;
  color: #191714;
}
.rf-rail-total-row.is-total span:last-child {
  color: #191714;
}
.rf-rail-foot {
  padding: 14px 20px;
  border-top: 1px solid #e7e3da;
  display: flex;
  gap: 9px;
  flex-shrink: 0;
}
.rf-rail-foot .rf-btn {
  height: 40px;
  border-radius: 9px;
}
.rf-rail-next {
  flex-grow: 1;
  font-size: 13.5px;
}

/* ================= SearchSelect ================= */
.rf-ss {
  width: 100%;
  background: #fff;
  border: 1px solid #ddd7cb;
  border-radius: 11px;
  box-shadow: 0 16px 44px rgba(40, 34, 22, 0.18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 352px;
}
.rf-ss-search {
  padding: 10px 12px;
  border-bottom: 1px solid #f0ece3;
  flex-shrink: 0;
}
.rf-ss-field {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  border: 1px solid var(--rf-brand-lite);
  border-radius: 8px;
  background: #fdfcfa;
  padding: 0 11px;
}
.rf-ss-field input {
  flex-grow: 1;
  min-width: 0;
  border: none;
  background: none;
  outline: none;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.rf-ss-icon {
  width: 13px;
  height: 13px;
  border: 1.5px solid #a29b8d;
  border-radius: 50%;
  display: block;
  flex-shrink: 0;
}
.rf-ss-clear {
  border: none;
  background: none;
  padding: 0;
  font-size: 15px;
  line-height: 1;
  color: #bdb6a7;
  cursor: pointer;
}
.rf-ss-list {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 6px 0;
}
.rf-ss-grouplabel {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #a29b8d;
  padding: 8px 14px 5px;
  white-space: nowrap;
}
.rf-ss-row {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 8px 14px;
  cursor: pointer;
}
.rf-ss-row.is-cursor {
  background: #fbf9f5;
}
.rf-ss-row.is-selected {
  background: var(--rf-brand-wash);
}
.rf-ss-chip {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.rf-ss-text {
  flex-grow: 1;
  min-width: 0;
}
.rf-ss-primary {
  font-size: 13.5px;
  font-weight: 500;
  color: #191714;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-ss-row.is-selected .rf-ss-primary {
  font-weight: 600;
}
.rf-ss-secondary {
  font-size: 11.5px;
  color: #8b8477;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-ss-meta {
  font-size: 11.5px;
  color: #a29b8d;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.rf-ss-tick {
  font-size: 12px;
  font-weight: 700;
  color: var(--rf-brand);
  width: 13px;
  text-align: right;
  flex-shrink: 0;
}
.rf-ss-empty {
  padding: 22px 14px;
  text-align: center;
  font-size: 12.5px;
  color: #8b8477;
  line-height: 1.5;
}
.rf-ss-addbar {
  flex-shrink: 0;
  border: none;
  border-top: 1px solid #f0ece3;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  background: #fbf9f5;
  width: 100%;
  font-family: inherit;
}
.rf-ss-addbar:disabled {
  cursor: default;
  opacity: 0.55;
}
.rf-ss-addbar:disabled:hover {
  background: #fbf9f5;
}
.rf-ss-addbar:hover {
  background: #f6f1e6;
}
.rf-ss-plus {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1px dashed #ccc4b2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 1;
  color: var(--rf-brand);
  flex-shrink: 0;
}
.rf-ss-addlabel {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--rf-brand);
  white-space: nowrap;
}
.rf-ss-spacer {
  flex-grow: 1;
}
.rf-ss-hint {
  font-size: 11px;
  color: #bdb6a7;
  white-space: nowrap;
}

/* --- add-new form inside the panel --- */
.rf-ss-addform {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.rf-ss-addhead {
  padding: 12px 14px 10px;
  border-bottom: 1px solid #f0ece3;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.rf-ss-back {
  border: none;
  background: none;
  padding: 0;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-brand);
  cursor: pointer;
  white-space: nowrap;
}
.rf-ss-addtitle {
  font-size: 13.5px;
  font-weight: 600;
  color: #191714;
  white-space: nowrap;
}
.rf-ss-addbody {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px;
}
.rf-ss-addgrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 11px 12px;
}
.rf-ss-addfield {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}
.rf-ss-addfield label,
.rf-ss-kinds label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8b8477;
  white-space: nowrap;
}
.rf-ss-addfield input {
  width: 100%;
  height: 36px;
  border: 1px solid #e7e3da;
  border-radius: 8px;
  background: #fdfcfa;
  padding: 0 11px;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  outline: none;
}
.rf-ss-addfield input:focus {
  border-color: var(--rf-brand-lite);
  background: #fff;
}
.rf-ss-kinds {
  margin-top: 13px;
}
.rf-ss-kindrow {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: 7px;
}
.rf-ss-note {
  margin: 13px 0 0;
  font-size: 11.5px;
  color: #a29b8d;
  line-height: 1.5;
  text-wrap: pretty;
}
.rf-ss-addfoot {
  flex-shrink: 0;
  border-top: 1px solid #f0ece3;
  padding: 11px 14px;
  display: flex;
  gap: 8px;
  background: #fbf9f5;
}
.rf-ss-addfoot .rf-btn {
  height: 36px;
  font-size: 12.5px;
}
.rf-ss-save {
  flex-grow: 1;
}

/* shared chip button */
.rf-chip-btn {
  border: 1px solid #e7e3da;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 7px;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  background: #fff;
  color: #4a453c;
  white-space: nowrap;
}
.rf-chip-btn:hover {
  border-color: #d8cfb8;
}
.rf-chip-btn.is-active {
  background: var(--rf-brand-tint);
  color: var(--rf-brand-deep);
  border-color: #d8cfb8;
}
.rf-chip-btn.is-grow {
  flex-grow: 1;
}

/* ================= ProductPickerModal ================= */
.rf-modal-scrim {
  position: absolute;
  inset: 0;
  z-index: 60;
  background: rgba(25, 23, 20, 0.42);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
}
.rf-modal {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(25, 23, 20, 0.32);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.rf-modal-head {
  padding: 16px 22px;
  border-bottom: 1px solid #e7e3da;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}
.rf-modal-title {
  font-size: 23px;
  line-height: 1.15;
  color: #191714;
  white-space: nowrap;
}
.rf-modal-context {
  font-size: 12.5px;
  color: #6f6a60;
  margin-top: 2px;
  white-space: nowrap;
}
.rf-modal-body {
  flex-grow: 1;
  min-height: 0;
  display: flex;
}
.rf-icon-btn {
  width: 34px;
  height: 34px;
  border: 1px solid #e7e3da;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8b8477;
  font-size: 18px;
  line-height: 1;
  flex-shrink: 0;
}
.rf-icon-btn:hover {
  background: #f6f4ef;
}
.rf-icon-btn.is-small {
  width: 26px;
  height: 26px;
  font-size: 15px;
  border-color: var(--rf-brand-line);
  border-radius: 7px;
  background: none;
}
.rf-icon-btn.is-small:hover {
  background: var(--rf-brand-tint);
}

/* --- browse pane --- */
.rf-pp-browse {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e7e3da;
}
/* Nothing picked -> no configure pane, so the browse pane is the last child
   and the divider would sit against the modal edge. */
.rf-pp-browse:last-child {
  border-right: none;
}
.rf-pp-filters {
  padding: 14px 20px 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
}
.rf-pp-search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #e7e3da;
  border-radius: 9px;
  background: #fdfcfa;
}
.rf-pp-search input {
  flex-grow: 1;
  min-width: 0;
  border: none;
  background: none;
  outline: none;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.rf-pp-search:focus-within {
  border-color: var(--rf-brand-lite);
}
.rf-pp-types {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.rf-pp-grid-wrap {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 20px 16px;
}
.rf-pp-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 10px;
}
.rf-pp-card {
  border: 1.5px solid #e7e3da;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}
.rf-pp-card:hover {
  border-color: #d8cfb8;
}
.rf-pp-card.is-selected {
  border-color: var(--rf-brand-lite);
  background: var(--rf-brand-wash);
}
.rf-pp-photo {
  position: relative;
  width: 100%;
  height: 104px;
  background: #f0ece3;
  flex-shrink: 0;
}
.rf-pp-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.rf-pp-photo-empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11.5px;
  color: #a29b8d;
}
.rf-pp-tick {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.82);
  border: 1.5px solid rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
  pointer-events: none;
}
.rf-pp-tick.is-on {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
}
.rf-pp-card-body {
  padding: 9px 11px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-grow: 1;
}
.rf-pp-card-top {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}
.rf-pp-accent {
  width: 3px;
  height: 24px;
  border-radius: 2px;
  flex-shrink: 0;
}
.rf-pp-name {
  font-size: 12.5px;
  font-weight: 600;
  color: #191714;
  line-height: 1.25;
  text-wrap: pretty;
}
.rf-pp-code {
  font-size: 11px;
  color: #a29b8d;
  margin-top: 2px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.rf-pp-card-foot {
  margin-top: auto;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: 11px;
  color: #8b8477;
  white-space: nowrap;
}
.rf-pp-price {
  font-size: 12.5px;
  font-weight: 600;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.rf-pp-browse-foot {
  padding: 10px 20px;
  border-top: 1px solid #f0ece3;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-size: 12px;
  color: #8b8477;
}

/* --- configure pane --- */
.rf-pp-config {
  width: 392px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: #fbf9f5;
}
.rf-pp-config-scroll {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.rf-pp-picked {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.rf-pp-thumb {
  width: 96px;
  height: 96px;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
  background: #f0ece3;
  border: 1px solid #e7e3da;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11.5px;
  color: #a29b8d;
}
.rf-pp-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.rf-pp-picked-name {
  font-size: 15px;
  font-weight: 600;
  color: #191714;
  line-height: 1.25;
  text-wrap: pretty;
}
.rf-pp-picked-code {
  font-size: 12px;
  color: #a29b8d;
  margin-top: 3px;
  font-variant-numeric: tabular-nums;
}
.rf-pp-block .rf-label {
  margin-bottom: 7px;
}
.rf-pp-sizes {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.rf-pp-size {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border: 1.5px solid #e7e3da;
  background: #fff;
  border-radius: 9px;
  cursor: pointer;
}
.rf-pp-size:hover {
  border-color: #d8cfb8;
}
.rf-pp-size.is-on {
  border-color: var(--rf-brand-lite);
  background: var(--rf-brand-wash);
}
.rf-radio {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1.5px solid #ddd7cb;
  background: #fff;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
}
.rf-pp-size.is-on .rf-radio {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
}
.rf-pp-size-label {
  flex-grow: 1;
  font-size: 13px;
  font-weight: 500;
  color: #191714;
}
.rf-pp-size.is-on .rf-pp-size-label {
  font-weight: 600;
}
.rf-pp-size-price {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.rf-pp-row2 {
  display: flex;
  gap: 12px;
}
.rf-pp-qty-wrap {
  width: 132px;
  flex-shrink: 0;
}
.rf-pp-custom-wrap {
  flex-grow: 1;
  min-width: 0;
}
.rf-stepper {
  display: flex;
  align-items: center;
  height: 38px;
  border: 1px solid #e7e3da;
  border-radius: 9px;
  background: #fff;
  overflow: hidden;
}
.rf-stepper button {
  width: 36px;
  height: 100%;
  border: none;
  background: none;
  cursor: pointer;
  color: #6f6a60;
  font-size: 16px;
  line-height: 1;
}
.rf-stepper button:first-child {
  border-right: 1px solid #f0ece3;
}
.rf-stepper button:last-child {
  border-left: 1px solid #f0ece3;
}
.rf-stepper button:hover {
  background: #f6f4ef;
}
.rf-stepper span,
.rf-stepper input {
  flex: 1 1 48px;
  width: 48px;
  min-width: 0;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.rf-stepper input {
  height: 100%;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  background: none;
  font-family: inherit;
  outline: none;
}
.rf-stepper input:focus {
  background: #faf8f3;
}
.rf-prefix-input {
  display: flex;
  align-items: center;
  height: 38px;
  border: 1px solid #e7e3da;
  border-radius: 9px;
  background: #fff;
  padding: 0 12px;
  gap: 5px;
}
.rf-prefix-input span {
  font-size: 13px;
  color: #a29b8d;
}
.rf-prefix-input input {
  flex-grow: 1;
  min-width: 0;
  border: none;
  background: none;
  outline: none;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.rf-prefix-input:focus-within {
  border-color: var(--rf-brand-lite);
}
.rf-check-meta {
  font-size: 12px;
  color: #8b8477;
  font-variant-numeric: tabular-nums;
}
.rf-pp-sash {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-top: 8px;
}
.rf-pp-config textarea {
  width: 100%;
  border: 1px solid #e7e3da;
  border-radius: 9px;
  background: #fff;
  padding: 9px 12px;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  outline: none;
  resize: none;
  margin-top: 8px;
}
.rf-pp-sash textarea {
  margin-top: 0;
}
.rf-pp-config textarea:focus {
  border-color: var(--rf-brand-lite);
}
.rf-pp-config-foot {
  flex-shrink: 0;
  border-top: 1px solid #e7e3da;
  background: #fff;
  padding: 14px 20px;
  display: flex;
  flex-direction: column;
  gap: 11px;
}
.rf-pp-totals {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.rf-pp-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12.5px;
  color: #8b8477;
}
.rf-pp-total-row span:last-child {
  color: #4a453c;
  font-variant-numeric: tabular-nums;
}
.rf-pp-total-row.is-total {
  font-size: 15px;
  font-weight: 600;
  color: #191714;
}
.rf-pp-total-row.is-total span:last-child {
  color: #191714;
}
.rf-pp-actions {
  display: flex;
  gap: 9px;
}
.rf-pp-actions .rf-btn {
  height: 40px;
  border-radius: 9px;
}
.rf-pp-add {
  flex-grow: 1;
  font-size: 13.5px;
}
.rf-pp-keep {
  text-align: center;
  font-size: 11.5px;
  color: #a29b8d;
}

/* ================= responsive: tablet ================= */
@media (max-width: 1200px) {
  .rf-neworder-body {
    flex-direction: column;
  }
  .rf-rail {
    width: 100%;
    border-left: none;
    border-top: 1px solid #e7e3da;
  }
  .rf-grid-3 {
    grid-template-columns: 1fr 1fr;
  }
  .rf-modal-body {
    flex-direction: column;
  }
  .rf-pp-config {
    width: 100%;
  }
  .rf-picker-panel {
    min-width: 0;
  }
}

/* ================= additions for the wired page =================
   .rf-check / .rf-link live in login-redesign.css, which this page does not
   load. Repeated here so /new-order only needs dashboard-redesign.css. */
.rf-check {
  display: flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.rf-check input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.rf-check-box {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  border: 1.5px solid #ddd7cb;
  border-radius: 5px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: transparent;
}
.rf-check input:checked + .rf-check-box {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
  color: #fff;
}
.rf-check input:focus-visible + .rf-check-box {
  border-color: var(--rf-brand-lite);
}
.rf-check-label {
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.rf-link {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-brand);
}
.rf-link:hover {
  text-decoration: underline;
}

/* Native select / date controls dressed as .rf-input-shell values. */
.rf-input-shell select,
.rf-input-shell input[type="date"] {
  flex-grow: 1;
  min-width: 0;
  border: none;
  background: none;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  padding: 0;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  cursor: pointer;
}
.rf-input-shell select:invalid,
.rf-input-shell input[type="date"]:not(:valid) {
  color: #bdb6a7;
}
/* **UNPAID** — red and bold in the open list and once chosen, as on the
   old form; browsers that ignore option colours still show the chosen
   value red */
.rf-input-shell select.is-unpaid,
.rf-input-shell select option.is-unpaid {
  color: #dc4141;
  font-weight: 700;
}
.rf-input-shell input[type="date"]::-webkit-calendar-picker-indicator {
  opacity: 0.35;
  cursor: pointer;
}
.rf-input-shell textarea {
  flex-grow: 1;
  border: none;
  background: none;
  outline: none;
  resize: none;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.rf-input-shell.is-disabled {
  background: #fbf9f5;
}
.rf-input-shell.is-disabled input,
.rf-input-shell.is-disabled select {
  color: #6f6a60;
  cursor: not-allowed;
}

/* The destination card's "Other address" free-text row. */
.rf-dest-input {
  margin-top: 9px;
  height: 34px;
}
.rf-dest-time-input {
  width: 132px;
  height: 26px;
  padding: 0 7px;
  border-radius: 6px;
}
.rf-dest-time-input input {
  font-size: 11.5px;
  color: #6f6a60;
}

/* Delivery fee — a plain field at the top of the rail, under the order's
   name, so it's seen before the products rather than after the totals. */
.rf-rail-fee-block {
  flex-shrink: 0;
  padding: 14px 20px;
  border-bottom: 1px solid #f0ece3;
}
.rf-fee-custom-k {
  color: #8b8477;
}
.rf-fee-custom input {
  font-variant-numeric: tabular-nums;
}

/* Skeleton tiles while the catalogue / picker lists load. */
.rf-skeleton {
  background: #f0ece3;
  border-radius: 10px;
  animation: rf-pulse 1.2s ease-in-out infinite;
}
.rf-pp-skeleton {
  height: 176px;
}
.rf-ss-loading {
  padding: 22px 14px;
  text-align: center;
  font-size: 12.5px;
  color: #a29b8d;
}
@keyframes rf-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

/* Inline validation on the required fields. */
.rf-input-shell.is-error,
.rf-person-block .rf-input-shell.is-error {
  border-color: #a8483e;
}
.rf-banner {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 14px;
  border: 1px solid #e6cdc8;
  background: #fdf5f3;
  border-radius: 9px;
  font-size: 12.5px;
  color: #a8483e;
}

/* The shell (.rf-content) centres and top-aligns whatever page it renders;
   this screen is a full-bleed two-pane layout, so it opts out. */
.rf-content > .rf-neworder {
  align-self: stretch;
  width: 100%;
  background: #f6f4ef;
}

/* ================= retail form ================= */
.rf-input-shell.is-area {
  height: auto;
  padding: 8px 12px;
}
.rf-retail-sched {
  margin: 2px 0 14px;
}
.rf-retail-sched .rf-check-meta {
  margin-left: 4px;
}

/* Product-type filter: capped at ten chips behind a show more / less toggle. */
.rf-pp-types-toggle {
  border-style: dashed;
  color: var(--rf-brand);
}
.rf-pp-types-toggle:hover {
  border-color: var(--rf-brand-lite);
  background: var(--rf-brand-wash);
}

/* ================= funeral director commission ================= */
/* the check row takes the input shell's height so it sits level with the
   director picker in the other grid column */
.rf-fd-commission .rf-check {
  min-height: 38px;
}
.rf-fd-commission .rf-hint {
  line-height: 1.4;
}
.rf-rail-total-row.is-commission {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #e6e0d4;
}
.rf-rail-total-row.is-commission span {
  color: #8b8477;
  font-size: 12px;
}
/* the total less the director's cut — what the shop keeps of the invoice */
.rf-rail-total-row.is-net span {
  font-weight: 600;
}

/* ---------- address field with Google suggestions (AddressAutocomplete) ---------- */
.rf-addr {
  position: relative;
  flex-grow: 1;
  min-width: 0;
  align-self: stretch;
  display: flex;
  align-items: center;
}
/* the list spans the whole input shell, not just the text, so it lines up
   with the field's border (the shell has 12px padding + 1px border) */
.rf-addr-list {
  position: absolute;
  top: calc(100% + 6px);
  left: -13px;
  right: -13px;
  z-index: 70;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 10px;
  box-shadow: 0 14px 34px rgba(40, 34, 22, 0.16);
  padding: 5px;
  max-height: 320px;
  overflow-y: auto;
}
.rf-addr-item {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 9px 10px;
  border-radius: 7px;
  cursor: pointer;
}
.rf-addr-item.is-active {
  background: var(--rf-brand-tint, #f6ecd8);
}
.rf-addr-main {
  font-size: 13.5px;
  font-weight: 600;
  color: #191714;
}
.rf-addr-sub {
  font-size: 12px;
  color: #8b8477;
}
.rf-addr-note {
  padding: 9px 10px;
  font-size: 12.5px;
  color: #8b8477;
}
.rf-addr-foot {
  padding: 6px 10px 3px;
  border-top: 1px solid #f0ece3;
  margin-top: 4px;
  font-size: 10.5px;
  color: #a29b8d;
}

/* rail lines open in the product picker with everything they were
   selected with */
.rf-rail-line.is-clickable {
  cursor: pointer;
}
.rf-rail-line.is-clickable:hover {
  background: #faf8f3;
}
.rf-rail-line.is-clickable:focus-visible {
  outline: 2px solid var(--rf-brand-lite);
  outline-offset: 1px;
}

/* ================= director's special instructions ================= */
/* fixed, not absolute — the form is taller than the window */
.rf-fdnote-scrim {
  position: fixed;
  inset: 0;
  z-index: 70;
  background: rgba(25, 23, 20, 0.42);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.rf-fdnote {
  width: 100%;
  max-width: 460px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(25, 23, 20, 0.32);
  padding: 22px 24px 18px;
}
.rf-fdnote-eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--rf-brand);
}
.rf-fdnote-title {
  margin-top: 4px;
  font-size: 22px;
  line-height: 1.2;
  color: #191714;
}
.rf-fdnote-body {
  margin-top: 14px;
  padding: 12px 14px;
  background: #faf7f0;
  border-left: 3px solid var(--rf-brand);
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.5;
  color: #191714;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.rf-fdnote-actions {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
}

/* ================= "Create in" — another business ================= */
.rf-form-bar {
  flex-wrap: wrap;
}
.rf-form-bar-business {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rf-form-bar-business .rf-label {
  margin: 0;
  white-space: nowrap;
}
.rf-form-bar-business .rf-input-shell {
  width: 220px;
}
/* the order is going somewhere other than the business on screen */
.rf-business-note {
  padding: 10px 14px;
  border: 1px solid #e3c98f;
  border-left: 3px solid #b8862b;
  border-radius: 8px;
  background: #fbf5e7;
  font-size: 13px;
  line-height: 1.45;
  color: #4a3b1c;
}
.rf-rail-business {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  border-radius: 20px;
  background: #fbf5e7;
  border: 1px solid #e3c98f;
  font-size: 11.5px;
  font-weight: 600;
  color: #7a5a17;
}
`, "",{"version":3,"sources":["webpack://./src/new-order.css"],"names":[],"mappings":"AAAA;;2EAE2E;;AAE3E,+CAA+C;AAC/C;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+DAA+D;AACjE;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gEAAgE;EAChE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;+DAC+D;AAC/D,qCAAqC;AACrC;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gEAAgE;EAChE,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gEAAgE;EAChE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,8DAA8D;EAC9D,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gEAAgE;EAChE,cAAc;EACd,aAAa;AACf;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8DAA8D;EAC9D,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;AACA;sDACsD;AACtD;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gEAAgE;EAChE,cAAc;AAChB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gEAAgE;EAChE,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,8DAA8D;EAC9D,cAAc;EACd,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;AACF;;AAEA;;yEAEyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,kCAAkC;AACpC;AACA;EACE,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gEAAgE;EAChE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA,qEAAqE;AACrE;;EAEE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,gEAAgE;EAChE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;;cAEc;AACd;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gEAAgE;EAChE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;yEACyE;AACzE;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,kCAAkC;AACpC;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA,8CAA8C;AAC9C;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;iEACiE;AACjE;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA,oEAAoE;AACpE;6CAC6C;AAC7C;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA,2EAA2E;AAC3E;EACE,gBAAgB;AAClB;;AAEA,sFAAsF;AACtF;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;sEACsE;AACtE;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;kBACkB;AAClB;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE,6DAA6D;AAC7D;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* New order page + SearchSelect + ProductPickerModal.\n   Depends on dashboard-redesign.css for the shell (.rf-app, .rf-topbar,\n   .rf-btn, .rf-serif, .rf-spacer, .rf-check, .rf-link). Load that first. */\n\n/* ================= layout ================= */\n.rf-neworder {\n  flex-grow: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.rf-neworder-body {\n  flex-grow: 1;\n  min-height: 0;\n  display: flex;\n}\n.rf-form {\n  flex-grow: 1;\n  min-width: 0;\n  padding: 22px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  /* no overflow:hidden — picker panels must escape these cards */\n}\n\n/* ================= step bar ================= */\n.rf-steps {\n  background: #fff;\n  border-bottom: 1px solid #e7e3da;\n  padding: 12px 28px;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n.rf-step {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 18px 0 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-family: inherit;\n}\n.rf-step-badge {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n  border: 1.5px solid #e7e3da;\n  background: #fff;\n  color: #a29b8d;\n}\n.rf-step.is-active .rf-step-badge {\n  background: #191714;\n  border-color: #191714;\n  color: #fff;\n}\n.rf-step.is-done .rf-step-badge {\n  background: var(--rf-brand-tint);\n  border-color: var(--rf-brand-line);\n  color: var(--rf-brand);\n}\n.rf-step-label {\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #a29b8d;\n  white-space: nowrap;\n}\n.rf-step.is-active .rf-step-label {\n  font-weight: 600;\n  color: #191714;\n}\n.rf-step.is-done .rf-step-label {\n  color: #4a453c;\n}\n.rf-step-line {\n  width: 34px;\n  height: 1.5px;\n  background: #e7e3da;\n  display: block;\n  margin-left: 8px;\n}\n.rf-step:last-of-type .rf-step-line {\n  display: none;\n}\n.rf-step.is-done .rf-step-line {\n  background: #d8cfb8;\n}\n.rf-steps-meta {\n  font-size: 12.5px;\n  color: #8b8477;\n  white-space: nowrap;\n}\n\n/* ================= fields ================= */\n.rf-form-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.rf-form-bar-note {\n  font-size: 12.5px;\n  color: #8b8477;\n  white-space: nowrap;\n}\n.rf-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 16px;\n}\n.rf-grid-3 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 14px 16px;\n  margin-bottom: 16px;\n}\n.rf-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n.rf-field-picker {\n  position: relative;\n}\n.rf-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #8b8477;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n}\n.rf-req {\n  color: #a8483e;\n}\n.rf-input-shell {\n  height: 38px;\n  border: 1px solid #e7e3da;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  gap: 8px;\n}\n.rf-input-shell input {\n  flex-grow: 1;\n  min-width: 0;\n  border: none;\n  background: none;\n  outline: none;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.rf-input-shell input::placeholder {\n  color: #bdb6a7;\n}\n.rf-input-shell:focus-within {\n  border-color: var(--rf-brand-lite);\n}\n.rf-input-shell.is-picker {\n  cursor: pointer;\n}\n.rf-input-shell.is-picker:hover,\n.rf-input-shell.is-open {\n  border-color: var(--rf-brand-lite);\n}\n.rf-picker-value {\n  flex-grow: 1;\n  min-width: 0;\n  font-size: 13.5px;\n  color: #191714;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-picker-placeholder {\n  flex-grow: 1;\n  min-width: 0;\n  font-size: 13.5px;\n  color: #a29b8d;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-affordance {\n  font-size: 11px;\n  color: #bdb6a7;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.rf-hint {\n  font-size: 11.5px;\n  color: #a29b8d;\n}\n.rf-hint.is-warn {\n  color: #a8483e;\n}\n\n/* picker panel positioning — the component itself is position-agnostic */\n.rf-picker-panel {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  min-width: 380px;\n  z-index: 40;\n}\n.rf-picker-panel.is-down {\n  top: 62px;\n}\n.rf-picker-panel.is-up {\n  bottom: 48px;\n}\n.rf-picker-wide {\n  max-width: 520px;\n  min-width: 420px;\n}\n\n/* ================= person record card ================= */\n.rf-person-block {\n  position: relative;\n  margin-bottom: 14px;\n}\n.rf-person {\n  border: 1.5px solid #d8cfb8;\n  background: var(--rf-brand-wash);\n  border-radius: 10px;\n  padding: 12px 14px;\n  display: flex;\n  align-items: flex-start;\n  gap: 13px;\n}\n.rf-person-chip {\n  width: 38px;\n  height: 38px;\n  border-radius: 9px;\n  background: #f0e3c8;\n  color: var(--rf-brand-deep);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n}\n.rf-person-main {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n.rf-person-head {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  flex-wrap: wrap;\n}\n.rf-person-name {\n  font-size: 19px;\n  line-height: 1.15;\n  color: #191714;\n}\n.rf-person-badge {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--rf-brand-deep);\n  background: #f0e3c8;\n  padding: 2px 7px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n.rf-person-dates {\n  font-size: 12px;\n  color: #8b8477;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n.rf-person-facts {\n  display: flex;\n  flex-wrap: wrap;\n}\n.rf-person-fact {\n  padding-right: 20px;\n  margin-right: 20px;\n  border-right: 1px solid var(--rf-brand-line);\n}\n.rf-person-fact:last-child {\n  border-right: none;\n  margin-right: 0;\n  padding-right: 0;\n}\n.rf-person-fact-k {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  white-space: nowrap;\n  margin-bottom: 2px;\n}\n.rf-person-fact-v {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #191714;\n  white-space: nowrap;\n}\n.rf-person-warn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #f0e3c8;\n  font-size: 12px;\n  color: #6f6a60;\n  text-wrap: pretty;\n}\n.rf-person-warn-bar {\n  width: 3px;\n  height: 18px;\n  border-radius: 2px;\n  background: #b0872f;\n  flex-shrink: 0;\n}\n.rf-person-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n\n/* ================= destination pickers ================= */\n.rf-dest {\n  border: 1px solid #eee9df;\n  background: #fbf9f5;\n  border-radius: 10px;\n  padding: 13px 15px;\n}\n.rf-dest-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 9px;\n}\n.rf-dest-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n}\n.rf-dest-time {\n  font-size: 11.5px;\n  color: #a29b8d;\n  white-space: nowrap;\n}\n.rf-dest-address {\n  font-size: 13px;\n  color: #191714;\n  line-height: 1.4;\n  text-wrap: pretty;\n  margin-top: 9px;\n}\n.rf-segmented.is-full {\n  width: 100%;\n}\n.rf-segmented.is-full button {\n  flex-grow: 1;\n  padding: 5px 8px;\n  font-size: 11.5px;\n}\n\n/* ================= live summary rail ================= */\n.rf-rail {\n  width: 392px;\n  flex-shrink: 0;\n  border-left: 1px solid #e7e3da;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n.rf-rail-head {\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #f0ece3;\n  flex-shrink: 0;\n}\n.rf-rail-name {\n  font-size: 22px;\n  line-height: 1.15;\n  color: #191714;\n  margin-top: 4px;\n}\n.rf-rail-meta {\n  font-size: 12.5px;\n  color: #6f6a60;\n  margin-top: 3px;\n}\n.rf-rail-body {\n  flex-grow: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.rf-rail-group {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n.rf-rail-group-title {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n}\n.rf-rail-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.rf-rail-line {\n  border: 1px solid #e7e3da;\n  border-radius: 9px;\n  padding: 9px 11px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.rf-rail-line:hover {\n  border-color: #d8cfb8;\n}\n.rf-rail-accent {\n  width: 3px;\n  height: 26px;\n  border-radius: 2px;\n  background: var(--rf-brand-lite);\n  flex-shrink: 0;\n}\n.rf-rail-line-text {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rf-rail-line-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-rail-line-detail {\n  font-size: 11.5px;\n  color: #a29b8d;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* the sash wording, under its product — wraps, because the message is a\n   sentence and the whole point is being able to read it here */\n/* \"2 × $440.00 each + sash $30.00\" */\n.rf-rail-line-calc {\n  margin-top: 2px;\n  font-size: 11.5px;\n  color: #6f6a60;\n  font-variant-numeric: tabular-nums;\n}\n.rf-rail-line-sash {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  margin-top: 3px;\n}\n.rf-rail-sash-k {\n  font-size: 9.5px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n  flex-shrink: 0;\n}\n.rf-rail-sash-v {\n  font-size: 11.5px;\n  line-height: 1.35;\n  color: #4a453c;\n  overflow-wrap: anywhere;\n  text-wrap: pretty;\n}\n.rf-rail-qty {\n  font-size: 12.5px;\n  color: #4a453c;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.rf-rail-price {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.rf-rail-remove {\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1;\n  color: #c4bdad;\n  cursor: pointer;\n}\n.rf-rail-remove:hover {\n  color: #a8483e;\n}\n.rf-rail-empty {\n  width: 100%;\n  border: 1px dashed #ddd7cb;\n  border-radius: 9px;\n  padding: 14px;\n  background: none;\n  text-align: center;\n  font: 400 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #a29b8d;\n  cursor: pointer;\n}\n.rf-rail-empty:hover {\n  border-color: #d8cfb8;\n  color: var(--rf-brand);\n}\n.rf-rail-totals {\n  margin-top: auto;\n  border-top: 1px solid #f0ece3;\n  padding-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n.rf-rail-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12.5px;\n  color: #8b8477;\n}\n.rf-rail-total-row span:last-child {\n  color: #4a453c;\n  font-variant-numeric: tabular-nums;\n}\n.rf-rail-total-row.is-total {\n  font-size: 15px;\n  font-weight: 600;\n  color: #191714;\n}\n.rf-rail-total-row.is-total span:last-child {\n  color: #191714;\n}\n.rf-rail-foot {\n  padding: 14px 20px;\n  border-top: 1px solid #e7e3da;\n  display: flex;\n  gap: 9px;\n  flex-shrink: 0;\n}\n.rf-rail-foot .rf-btn {\n  height: 40px;\n  border-radius: 9px;\n}\n.rf-rail-next {\n  flex-grow: 1;\n  font-size: 13.5px;\n}\n\n/* ================= SearchSelect ================= */\n.rf-ss {\n  width: 100%;\n  background: #fff;\n  border: 1px solid #ddd7cb;\n  border-radius: 11px;\n  box-shadow: 0 16px 44px rgba(40, 34, 22, 0.18);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-height: 352px;\n}\n.rf-ss-search {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f0ece3;\n  flex-shrink: 0;\n}\n.rf-ss-field {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  border: 1px solid var(--rf-brand-lite);\n  border-radius: 8px;\n  background: #fdfcfa;\n  padding: 0 11px;\n}\n.rf-ss-field input {\n  flex-grow: 1;\n  min-width: 0;\n  border: none;\n  background: none;\n  outline: none;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.rf-ss-icon {\n  width: 13px;\n  height: 13px;\n  border: 1.5px solid #a29b8d;\n  border-radius: 50%;\n  display: block;\n  flex-shrink: 0;\n}\n.rf-ss-clear {\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: 15px;\n  line-height: 1;\n  color: #bdb6a7;\n  cursor: pointer;\n}\n.rf-ss-list {\n  flex-grow: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 6px 0;\n}\n.rf-ss-grouplabel {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  padding: 8px 14px 5px;\n  white-space: nowrap;\n}\n.rf-ss-row {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 8px 14px;\n  cursor: pointer;\n}\n.rf-ss-row.is-cursor {\n  background: #fbf9f5;\n}\n.rf-ss-row.is-selected {\n  background: var(--rf-brand-wash);\n}\n.rf-ss-chip {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n.rf-ss-text {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rf-ss-primary {\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #191714;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-ss-row.is-selected .rf-ss-primary {\n  font-weight: 600;\n}\n.rf-ss-secondary {\n  font-size: 11.5px;\n  color: #8b8477;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-ss-meta {\n  font-size: 11.5px;\n  color: #a29b8d;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n.rf-ss-tick {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--rf-brand);\n  width: 13px;\n  text-align: right;\n  flex-shrink: 0;\n}\n.rf-ss-empty {\n  padding: 22px 14px;\n  text-align: center;\n  font-size: 12.5px;\n  color: #8b8477;\n  line-height: 1.5;\n}\n.rf-ss-addbar {\n  flex-shrink: 0;\n  border: none;\n  border-top: 1px solid #f0ece3;\n  padding: 9px 14px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  cursor: pointer;\n  background: #fbf9f5;\n  width: 100%;\n  font-family: inherit;\n}\n.rf-ss-addbar:disabled {\n  cursor: default;\n  opacity: 0.55;\n}\n.rf-ss-addbar:disabled:hover {\n  background: #fbf9f5;\n}\n.rf-ss-addbar:hover {\n  background: #f6f1e6;\n}\n.rf-ss-plus {\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  border: 1px dashed #ccc4b2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  line-height: 1;\n  color: var(--rf-brand);\n  flex-shrink: 0;\n}\n.rf-ss-addlabel {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--rf-brand);\n  white-space: nowrap;\n}\n.rf-ss-spacer {\n  flex-grow: 1;\n}\n.rf-ss-hint {\n  font-size: 11px;\n  color: #bdb6a7;\n  white-space: nowrap;\n}\n\n/* --- add-new form inside the panel --- */\n.rf-ss-addform {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n.rf-ss-addhead {\n  padding: 12px 14px 10px;\n  border-bottom: 1px solid #f0ece3;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.rf-ss-back {\n  border: none;\n  background: none;\n  padding: 0;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-brand);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.rf-ss-addtitle {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #191714;\n  white-space: nowrap;\n}\n.rf-ss-addbody {\n  flex-grow: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 14px;\n}\n.rf-ss-addgrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 11px 12px;\n}\n.rf-ss-addfield {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n.rf-ss-addfield label,\n.rf-ss-kinds label {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8b8477;\n  white-space: nowrap;\n}\n.rf-ss-addfield input {\n  width: 100%;\n  height: 36px;\n  border: 1px solid #e7e3da;\n  border-radius: 8px;\n  background: #fdfcfa;\n  padding: 0 11px;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  outline: none;\n}\n.rf-ss-addfield input:focus {\n  border-color: var(--rf-brand-lite);\n  background: #fff;\n}\n.rf-ss-kinds {\n  margin-top: 13px;\n}\n.rf-ss-kindrow {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n  margin-top: 7px;\n}\n.rf-ss-note {\n  margin: 13px 0 0;\n  font-size: 11.5px;\n  color: #a29b8d;\n  line-height: 1.5;\n  text-wrap: pretty;\n}\n.rf-ss-addfoot {\n  flex-shrink: 0;\n  border-top: 1px solid #f0ece3;\n  padding: 11px 14px;\n  display: flex;\n  gap: 8px;\n  background: #fbf9f5;\n}\n.rf-ss-addfoot .rf-btn {\n  height: 36px;\n  font-size: 12.5px;\n}\n.rf-ss-save {\n  flex-grow: 1;\n}\n\n/* shared chip button */\n.rf-chip-btn {\n  border: 1px solid #e7e3da;\n  cursor: pointer;\n  padding: 6px 10px;\n  border-radius: 7px;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  background: #fff;\n  color: #4a453c;\n  white-space: nowrap;\n}\n.rf-chip-btn:hover {\n  border-color: #d8cfb8;\n}\n.rf-chip-btn.is-active {\n  background: var(--rf-brand-tint);\n  color: var(--rf-brand-deep);\n  border-color: #d8cfb8;\n}\n.rf-chip-btn.is-grow {\n  flex-grow: 1;\n}\n\n/* ================= ProductPickerModal ================= */\n.rf-modal-scrim {\n  position: absolute;\n  inset: 0;\n  z-index: 60;\n  background: rgba(25, 23, 20, 0.42);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n}\n.rf-modal {\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(25, 23, 20, 0.32);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.rf-modal-head {\n  padding: 16px 22px;\n  border-bottom: 1px solid #e7e3da;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n}\n.rf-modal-title {\n  font-size: 23px;\n  line-height: 1.15;\n  color: #191714;\n  white-space: nowrap;\n}\n.rf-modal-context {\n  font-size: 12.5px;\n  color: #6f6a60;\n  margin-top: 2px;\n  white-space: nowrap;\n}\n.rf-modal-body {\n  flex-grow: 1;\n  min-height: 0;\n  display: flex;\n}\n.rf-icon-btn {\n  width: 34px;\n  height: 34px;\n  border: 1px solid #e7e3da;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #8b8477;\n  font-size: 18px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n.rf-icon-btn:hover {\n  background: #f6f4ef;\n}\n.rf-icon-btn.is-small {\n  width: 26px;\n  height: 26px;\n  font-size: 15px;\n  border-color: var(--rf-brand-line);\n  border-radius: 7px;\n  background: none;\n}\n.rf-icon-btn.is-small:hover {\n  background: var(--rf-brand-tint);\n}\n\n/* --- browse pane --- */\n.rf-pp-browse {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #e7e3da;\n}\n/* Nothing picked -> no configure pane, so the browse pane is the last child\n   and the divider would sit against the modal edge. */\n.rf-pp-browse:last-child {\n  border-right: none;\n}\n.rf-pp-filters {\n  padding: 14px 20px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex-shrink: 0;\n}\n.rf-pp-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #e7e3da;\n  border-radius: 9px;\n  background: #fdfcfa;\n}\n.rf-pp-search input {\n  flex-grow: 1;\n  min-width: 0;\n  border: none;\n  background: none;\n  outline: none;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.rf-pp-search:focus-within {\n  border-color: var(--rf-brand-lite);\n}\n.rf-pp-types {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n.rf-pp-grid-wrap {\n  flex-grow: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 20px 16px;\n}\n.rf-pp-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  gap: 10px;\n}\n.rf-pp-card {\n  border: 1.5px solid #e7e3da;\n  background: #fff;\n  border-radius: 10px;\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n}\n.rf-pp-card:hover {\n  border-color: #d8cfb8;\n}\n.rf-pp-card.is-selected {\n  border-color: var(--rf-brand-lite);\n  background: var(--rf-brand-wash);\n}\n.rf-pp-photo {\n  position: relative;\n  width: 100%;\n  height: 104px;\n  background: #f0ece3;\n  flex-shrink: 0;\n}\n.rf-pp-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.rf-pp-photo-empty {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11.5px;\n  color: #a29b8d;\n}\n.rf-pp-tick {\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.82);\n  border: 1.5px solid rgba(255, 255, 255, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1;\n  pointer-events: none;\n}\n.rf-pp-tick.is-on {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n}\n.rf-pp-card-body {\n  padding: 9px 11px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex-grow: 1;\n}\n.rf-pp-card-top {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  min-width: 0;\n}\n.rf-pp-accent {\n  width: 3px;\n  height: 24px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n.rf-pp-name {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #191714;\n  line-height: 1.25;\n  text-wrap: pretty;\n}\n.rf-pp-code {\n  font-size: 11px;\n  color: #a29b8d;\n  margin-top: 2px;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.rf-pp-card-foot {\n  margin-top: auto;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  font-size: 11px;\n  color: #8b8477;\n  white-space: nowrap;\n}\n.rf-pp-price {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.rf-pp-browse-foot {\n  padding: 10px 20px;\n  border-top: 1px solid #f0ece3;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  font-size: 12px;\n  color: #8b8477;\n}\n\n/* --- configure pane --- */\n.rf-pp-config {\n  width: 392px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fbf9f5;\n}\n.rf-pp-config-scroll {\n  flex-grow: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.rf-pp-picked {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n.rf-pp-thumb {\n  width: 96px;\n  height: 96px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #f0ece3;\n  border: 1px solid #e7e3da;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11.5px;\n  color: #a29b8d;\n}\n.rf-pp-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.rf-pp-picked-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #191714;\n  line-height: 1.25;\n  text-wrap: pretty;\n}\n.rf-pp-picked-code {\n  font-size: 12px;\n  color: #a29b8d;\n  margin-top: 3px;\n  font-variant-numeric: tabular-nums;\n}\n.rf-pp-block .rf-label {\n  margin-bottom: 7px;\n}\n.rf-pp-sizes {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.rf-pp-size {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  border: 1.5px solid #e7e3da;\n  background: #fff;\n  border-radius: 9px;\n  cursor: pointer;\n}\n.rf-pp-size:hover {\n  border-color: #d8cfb8;\n}\n.rf-pp-size.is-on {\n  border-color: var(--rf-brand-lite);\n  background: var(--rf-brand-wash);\n}\n.rf-radio {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  border: 1.5px solid #ddd7cb;\n  background: #fff;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1;\n}\n.rf-pp-size.is-on .rf-radio {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n}\n.rf-pp-size-label {\n  flex-grow: 1;\n  font-size: 13px;\n  font-weight: 500;\n  color: #191714;\n}\n.rf-pp-size.is-on .rf-pp-size-label {\n  font-weight: 600;\n}\n.rf-pp-size-price {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.rf-pp-row2 {\n  display: flex;\n  gap: 12px;\n}\n.rf-pp-qty-wrap {\n  width: 132px;\n  flex-shrink: 0;\n}\n.rf-pp-custom-wrap {\n  flex-grow: 1;\n  min-width: 0;\n}\n.rf-stepper {\n  display: flex;\n  align-items: center;\n  height: 38px;\n  border: 1px solid #e7e3da;\n  border-radius: 9px;\n  background: #fff;\n  overflow: hidden;\n}\n.rf-stepper button {\n  width: 36px;\n  height: 100%;\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: #6f6a60;\n  font-size: 16px;\n  line-height: 1;\n}\n.rf-stepper button:first-child {\n  border-right: 1px solid #f0ece3;\n}\n.rf-stepper button:last-child {\n  border-left: 1px solid #f0ece3;\n}\n.rf-stepper button:hover {\n  background: #f6f4ef;\n}\n.rf-stepper span,\n.rf-stepper input {\n  flex: 1 1 48px;\n  width: 48px;\n  min-width: 0;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.rf-stepper input {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: none;\n  font-family: inherit;\n  outline: none;\n}\n.rf-stepper input:focus {\n  background: #faf8f3;\n}\n.rf-prefix-input {\n  display: flex;\n  align-items: center;\n  height: 38px;\n  border: 1px solid #e7e3da;\n  border-radius: 9px;\n  background: #fff;\n  padding: 0 12px;\n  gap: 5px;\n}\n.rf-prefix-input span {\n  font-size: 13px;\n  color: #a29b8d;\n}\n.rf-prefix-input input {\n  flex-grow: 1;\n  min-width: 0;\n  border: none;\n  background: none;\n  outline: none;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.rf-prefix-input:focus-within {\n  border-color: var(--rf-brand-lite);\n}\n.rf-check-meta {\n  font-size: 12px;\n  color: #8b8477;\n  font-variant-numeric: tabular-nums;\n}\n.rf-pp-sash {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  margin-top: 8px;\n}\n.rf-pp-config textarea {\n  width: 100%;\n  border: 1px solid #e7e3da;\n  border-radius: 9px;\n  background: #fff;\n  padding: 9px 12px;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  outline: none;\n  resize: none;\n  margin-top: 8px;\n}\n.rf-pp-sash textarea {\n  margin-top: 0;\n}\n.rf-pp-config textarea:focus {\n  border-color: var(--rf-brand-lite);\n}\n.rf-pp-config-foot {\n  flex-shrink: 0;\n  border-top: 1px solid #e7e3da;\n  background: #fff;\n  padding: 14px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n}\n.rf-pp-totals {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.rf-pp-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12.5px;\n  color: #8b8477;\n}\n.rf-pp-total-row span:last-child {\n  color: #4a453c;\n  font-variant-numeric: tabular-nums;\n}\n.rf-pp-total-row.is-total {\n  font-size: 15px;\n  font-weight: 600;\n  color: #191714;\n}\n.rf-pp-total-row.is-total span:last-child {\n  color: #191714;\n}\n.rf-pp-actions {\n  display: flex;\n  gap: 9px;\n}\n.rf-pp-actions .rf-btn {\n  height: 40px;\n  border-radius: 9px;\n}\n.rf-pp-add {\n  flex-grow: 1;\n  font-size: 13.5px;\n}\n.rf-pp-keep {\n  text-align: center;\n  font-size: 11.5px;\n  color: #a29b8d;\n}\n\n/* ================= responsive: tablet ================= */\n@media (max-width: 1200px) {\n  .rf-neworder-body {\n    flex-direction: column;\n  }\n  .rf-rail {\n    width: 100%;\n    border-left: none;\n    border-top: 1px solid #e7e3da;\n  }\n  .rf-grid-3 {\n    grid-template-columns: 1fr 1fr;\n  }\n  .rf-modal-body {\n    flex-direction: column;\n  }\n  .rf-pp-config {\n    width: 100%;\n  }\n  .rf-picker-panel {\n    min-width: 0;\n  }\n}\n\n/* ================= additions for the wired page =================\n   .rf-check / .rf-link live in login-redesign.css, which this page does not\n   load. Repeated here so /new-order only needs dashboard-redesign.css. */\n.rf-check {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  cursor: pointer;\n  user-select: none;\n}\n.rf-check input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.rf-check-box {\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n  border: 1.5px solid #ddd7cb;\n  border-radius: 5px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: transparent;\n}\n.rf-check input:checked + .rf-check-box {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n  color: #fff;\n}\n.rf-check input:focus-visible + .rf-check-box {\n  border-color: var(--rf-brand-lite);\n}\n.rf-check-label {\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.rf-link {\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-brand);\n}\n.rf-link:hover {\n  text-decoration: underline;\n}\n\n/* Native select / date controls dressed as .rf-input-shell values. */\n.rf-input-shell select,\n.rf-input-shell input[type=\"date\"] {\n  flex-grow: 1;\n  min-width: 0;\n  border: none;\n  background: none;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  padding: 0;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  cursor: pointer;\n}\n.rf-input-shell select:invalid,\n.rf-input-shell input[type=\"date\"]:not(:valid) {\n  color: #bdb6a7;\n}\n/* **UNPAID** — red and bold in the open list and once chosen, as on the\n   old form; browsers that ignore option colours still show the chosen\n   value red */\n.rf-input-shell select.is-unpaid,\n.rf-input-shell select option.is-unpaid {\n  color: #dc4141;\n  font-weight: 700;\n}\n.rf-input-shell input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  opacity: 0.35;\n  cursor: pointer;\n}\n.rf-input-shell textarea {\n  flex-grow: 1;\n  border: none;\n  background: none;\n  outline: none;\n  resize: none;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.rf-input-shell.is-disabled {\n  background: #fbf9f5;\n}\n.rf-input-shell.is-disabled input,\n.rf-input-shell.is-disabled select {\n  color: #6f6a60;\n  cursor: not-allowed;\n}\n\n/* The destination card's \"Other address\" free-text row. */\n.rf-dest-input {\n  margin-top: 9px;\n  height: 34px;\n}\n.rf-dest-time-input {\n  width: 132px;\n  height: 26px;\n  padding: 0 7px;\n  border-radius: 6px;\n}\n.rf-dest-time-input input {\n  font-size: 11.5px;\n  color: #6f6a60;\n}\n\n/* Delivery fee — a plain field at the top of the rail, under the order's\n   name, so it's seen before the products rather than after the totals. */\n.rf-rail-fee-block {\n  flex-shrink: 0;\n  padding: 14px 20px;\n  border-bottom: 1px solid #f0ece3;\n}\n.rf-fee-custom-k {\n  color: #8b8477;\n}\n.rf-fee-custom input {\n  font-variant-numeric: tabular-nums;\n}\n\n/* Skeleton tiles while the catalogue / picker lists load. */\n.rf-skeleton {\n  background: #f0ece3;\n  border-radius: 10px;\n  animation: rf-pulse 1.2s ease-in-out infinite;\n}\n.rf-pp-skeleton {\n  height: 176px;\n}\n.rf-ss-loading {\n  padding: 22px 14px;\n  text-align: center;\n  font-size: 12.5px;\n  color: #a29b8d;\n}\n@keyframes rf-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.55;\n  }\n}\n\n/* Inline validation on the required fields. */\n.rf-input-shell.is-error,\n.rf-person-block .rf-input-shell.is-error {\n  border-color: #a8483e;\n}\n.rf-banner {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 10px 14px;\n  border: 1px solid #e6cdc8;\n  background: #fdf5f3;\n  border-radius: 9px;\n  font-size: 12.5px;\n  color: #a8483e;\n}\n\n/* The shell (.rf-content) centres and top-aligns whatever page it renders;\n   this screen is a full-bleed two-pane layout, so it opts out. */\n.rf-content > .rf-neworder {\n  align-self: stretch;\n  width: 100%;\n  background: #f6f4ef;\n}\n\n/* ================= retail form ================= */\n.rf-input-shell.is-area {\n  height: auto;\n  padding: 8px 12px;\n}\n.rf-retail-sched {\n  margin: 2px 0 14px;\n}\n.rf-retail-sched .rf-check-meta {\n  margin-left: 4px;\n}\n\n/* Product-type filter: capped at ten chips behind a show more / less toggle. */\n.rf-pp-types-toggle {\n  border-style: dashed;\n  color: var(--rf-brand);\n}\n.rf-pp-types-toggle:hover {\n  border-color: var(--rf-brand-lite);\n  background: var(--rf-brand-wash);\n}\n\n/* ================= funeral director commission ================= */\n/* the check row takes the input shell's height so it sits level with the\n   director picker in the other grid column */\n.rf-fd-commission .rf-check {\n  min-height: 38px;\n}\n.rf-fd-commission .rf-hint {\n  line-height: 1.4;\n}\n.rf-rail-total-row.is-commission {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px dashed #e6e0d4;\n}\n.rf-rail-total-row.is-commission span {\n  color: #8b8477;\n  font-size: 12px;\n}\n/* the total less the director's cut — what the shop keeps of the invoice */\n.rf-rail-total-row.is-net span {\n  font-weight: 600;\n}\n\n/* ---------- address field with Google suggestions (AddressAutocomplete) ---------- */\n.rf-addr {\n  position: relative;\n  flex-grow: 1;\n  min-width: 0;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n}\n/* the list spans the whole input shell, not just the text, so it lines up\n   with the field's border (the shell has 12px padding + 1px border) */\n.rf-addr-list {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: -13px;\n  right: -13px;\n  z-index: 70;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 10px;\n  box-shadow: 0 14px 34px rgba(40, 34, 22, 0.16);\n  padding: 5px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n.rf-addr-item {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding: 9px 10px;\n  border-radius: 7px;\n  cursor: pointer;\n}\n.rf-addr-item.is-active {\n  background: var(--rf-brand-tint, #f6ecd8);\n}\n.rf-addr-main {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #191714;\n}\n.rf-addr-sub {\n  font-size: 12px;\n  color: #8b8477;\n}\n.rf-addr-note {\n  padding: 9px 10px;\n  font-size: 12.5px;\n  color: #8b8477;\n}\n.rf-addr-foot {\n  padding: 6px 10px 3px;\n  border-top: 1px solid #f0ece3;\n  margin-top: 4px;\n  font-size: 10.5px;\n  color: #a29b8d;\n}\n\n/* rail lines open in the product picker with everything they were\n   selected with */\n.rf-rail-line.is-clickable {\n  cursor: pointer;\n}\n.rf-rail-line.is-clickable:hover {\n  background: #faf8f3;\n}\n.rf-rail-line.is-clickable:focus-visible {\n  outline: 2px solid var(--rf-brand-lite);\n  outline-offset: 1px;\n}\n\n/* ================= director's special instructions ================= */\n/* fixed, not absolute — the form is taller than the window */\n.rf-fdnote-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 70;\n  background: rgba(25, 23, 20, 0.42);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.rf-fdnote {\n  width: 100%;\n  max-width: 460px;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(25, 23, 20, 0.32);\n  padding: 22px 24px 18px;\n}\n.rf-fdnote-eyebrow {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n}\n.rf-fdnote-title {\n  margin-top: 4px;\n  font-size: 22px;\n  line-height: 1.2;\n  color: #191714;\n}\n.rf-fdnote-body {\n  margin-top: 14px;\n  padding: 12px 14px;\n  background: #faf7f0;\n  border-left: 3px solid var(--rf-brand);\n  border-radius: 6px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #191714;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n.rf-fdnote-actions {\n  margin-top: 18px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* ================= \"Create in\" — another business ================= */\n.rf-form-bar {\n  flex-wrap: wrap;\n}\n.rf-form-bar-business {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.rf-form-bar-business .rf-label {\n  margin: 0;\n  white-space: nowrap;\n}\n.rf-form-bar-business .rf-input-shell {\n  width: 220px;\n}\n/* the order is going somewhere other than the business on screen */\n.rf-business-note {\n  padding: 10px 14px;\n  border: 1px solid #e3c98f;\n  border-left: 3px solid #b8862b;\n  border-radius: 8px;\n  background: #fbf5e7;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #4a3b1c;\n}\n.rf-rail-business {\n  display: inline-block;\n  margin-top: 6px;\n  padding: 2px 8px;\n  border-radius: 20px;\n  background: #fbf5e7;\n  border: 1px solid #e3c98f;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #7a5a17;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
